import {Component, Input, OnInit} from '@angular/core';

import {OfferEntryDataService} from '../../../core/services/offer-entry-data.service';

import {Notification} from '../../models/notification';

@Component({
    selector: 'app-notification-item',
    templateUrl: './notification-item.component.html',
    styleUrls: ['./notification-item.component.css']
})
export class NotificationItemComponent implements OnInit {
    @Input() notification: Notification;

    dateHeader: any[] = [];

    icons: string[] = ['fa', 'fas', 'fa-3x'];

    constructor() { }

    ngOnInit() {
        this.generateDateHeader();
        switch (this.notification.actionId) {
            case 'DISCONNECTED':
                this.icons.push('fa-times-circle');
                break;
            case 'RECONNECTED':
                this.icons.push('fa-check-circle');
                break;
            case 'JOINED':
                this.icons.push('fa-sign-in');
                break;
            case 'LEFT':
                this.icons.push('fa-sign-out');
                break;
            case 'EDITED':
                this.icons.push('fa-edit');
                break;
            case 'ADD-REG':
                this.icons.push('fa-plus-circle');
                break;
            case 'REMOVE-REG':
                this.icons.push('fa-trash');
                break;
            case 'CREATE-GROUP':
                this.icons.push('fa-object-group');
                break;
            case 'UPDATE-GROUP':
                this.icons.push('fa-pencil');
                break;
            case 'REMOVE-GROUP':
                this.icons.push('fa-eraser');
                break;
            case 'ADD-REG-TO-GROUP':
                this.icons.push('fa-plus-square');
                break;
            case 'REMOVE-REG-FROM-GROUP':
                this.icons.push('fa-minus-square');
                break;
            case 'CREATE-MARKET-OFFER':
                this.icons.push('fa-file-excel');
                break;
            case 'LOAD-CLEARED-OFFER':
                this.icons.push('fa-upload');
                break;
            case 'CONFIRM-CLEARED-QUANTITY':
                this.icons.push('fa-check-circle');
                break;
            case 'NO-CLEARED-OFFER':
                this.icons.push('fa-exclamation-circle');
                break;
        }
    }

    generateDateHeader(): void {
        if (this.notification.date.length) {
            let num: number = 0;
            let date: string;
            for (const data of this.notification.date) {
                if (date !== undefined && date !== data) {
                    this.dateHeader.push({date: date, colspan: num});
                    num = 0;
                }
                date = data;
                num++;
            }
            this.dateHeader.push({date: date, colspan: num});
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/notification-item/notification-item.component.ts